import { render, staticRenderFns } from "./ScrollHolder.vue?vue&type=template&id=27662ebb&"
import script from "./ScrollHolder.vue?vue&type=script&lang=js&"
export * from "./ScrollHolder.vue?vue&type=script&lang=js&"
import style0 from "./ScrollHolder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports